import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-48@2x.jpg";
import v3Image from "../../assets/Switching/professional48.jpg";
import type { Product } from "../../types";
import { twoPointFiveTenGigabitEthernet } from "../product-groups/switching/2.5-10-gbe-1u";
import { professional } from "../product-groups/twoPointFiveTenGigabitEthernet/professional";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professional48: Product = {
  id: "professional48",
  productTitle: "Pro 48",
  description: "professional48.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-48"],
  storePathParts: {
    productSlug: "usw-pro-48",
    category: "switching-professional",
  },
  sku: "USW-Pro-48",
  productGroup: twoPointFiveTenGigabitEthernet,
  secondaryProductGroup: professional,
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 255,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 285 x 44 mm\n(17.4 x 11.2 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "48" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
